<div *ngIf="active" class="upp-barcode-scanning-frame" uppDataid="barcode-scanning-frame"
    tabindex="0"
    (click)="OnFrameClick()"
    (keydown)="OnFrameKeydown($event)"
>
    <div class="upp-barcode-scanning-message" uppDataid="barcode-scanning-message"
        tabindex="0"
        (click)="OnMessageClick($event)"
        (keydown.enter)="OnMessageClick($event)"
        (keydown.space)="OnMessageClick($event)"
    >
        <div class="upp-barcode-scanning-animation" aria-hidden="true">
            <ion-icon class="upp-barcode-scanning-icon" name="barcode-outline"></ion-icon>
            <span class="upp-barcode-scanning-beam"></span>
        </div>
        <p class="upp-barcode-scanning-text">{{tr('@place_barcode_listening')}}</p>
        <div class="upp-barcode-scanning-manual">
            <ion-item lines="none">
                <ion-input uppDataid="barcode-manual-input"
                    type="text"
                    maxlength="128"
                    [value]="ManualDraft"
                    [placeholder]="tr('@place_barcode_manual_placeholder')"
                    (ionInput)="OnManualInput($any($event).detail.value ?? '')"
                    (keydown.enter)="OnManualAcceptClick($event)"
                ></ion-input>
            </ion-item>
            <div *ngIf="ManualErrorKey" class="upp-barcode-scanning-manual-error">
                {{ tr(ManualErrorKey) }}
            </div>
            <ion-button uppDataid="barcode-manual-accept-button"
                expand="block"
                color="primary"
                [disabled]="!ManualAcceptable"
                (click)="OnManualAcceptClick($event)"
            >
                {{ tr('@place_barcode_accept') }}
            </ion-button>
        </div>
    </div>
</div>
